import { setClientEnv } from '@mc/client-env'

const coerce = (value) => {
  if (value === 'true') return true
  if (value === 'false') return false
  return value
}

export function init() {
  const entries =
    typeof window !== 'undefined'
      ? Object.entries(window.__ENV ?? {})
      : Object.entries(process.env).filter(([key]) =>
          key.startsWith('NEXT_PUBLIC_'),
        )

  setClientEnv(
    Object.fromEntries(entries.map(([key, value]) => [key, coerce(value)])),
  )
}
